import { useEffect, useState } from "react";

import Card from "@mui/material/Card";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Pagination from "@mui/material/Pagination";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Icon from "@mui/material/Icon";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import StatusCell from "layouts/ecommerce/orders/order-list/components/StatusCell";

import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useNavigate } from "react-router-dom";

import { getAllProducersApi, deleteProducerApi, toggleProducerStatusApi } from "api/superAdmin";

function ProducteursList() {
  const navigate = useNavigate();

  const [menu, setMenu] = useState(null);

  const [tableData, setTableData] = useState({
    producers: [],
    total: 0,
    pages: 1,
    page: 1,
  });

  const [openModal, setOpenModal] = useState(false);
  const [openModalItemData, setOpenModalItemData] = useState("");

  const [nameSearch, setNameSearch] = useState("");
  const [emailSearch, setEmailSearch] = useState("");
  const [pseudoSearch, setPseudoSearch] = useState("");
  const [typeSearch, setTypeSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("Tous");

  const [loading, setLoading] = useState(false);

  const [limitPerPage, setLimitPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const openMenu = (event) => setMenu(event.currentTarget);
  const closeMenu = () => setMenu(null);

  const getTableData = async (
    name = "",
    email = "",
    pseudo = "",
    type = "",
    status = "Tous",
    page = 1,
    limit = 10
  ) => {
    console.log("getTableData called with:", {
      name: name,
      email: email,
      pseudo: pseudo,
      type: type,
      status: status,
      page: page,
      limit: limit,
    });

    setLoading(true);
    try {
      const response = await getAllProducersApi(name, email, pseudo, type, status, page, limit);

      console.log("Producer Data:", response);

      setTableData({
        producers: response.producers,
        total: response.totalProducers,
        pages: response.totalPages,
        page: response.page,
      });
    } catch (err) {
      console.error("Error fetching producers:", err);
      toast.error(
        err.response?.data?.error ||
          "Une erreur s'est produite lors de la récupération de la liste des producteurs."
      );
      setTableData({ producers: [], total: 0, pages: 1, page: 1 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTableData(
      nameSearch,
      emailSearch,
      pseudoSearch,
      typeSearch,
      statusFilter,
      currentPage,
      limitPerPage
    );
  }, [currentPage, limitPerPage]);

  const handleCloseModal = (params) => {
    setOpenModal(false);
  };

  const handleEditeModal = (Data) => {
    setOpenModalItemData(Data);
    setOpenModal(true);
  };

  const handleEdite = (producerData) => {
    navigate(`/producteurs/modifier/${producerData._id}`);
  };

  const handleDeleteItem = async (producerId) => {
    const result = await Swal.fire({
      title: "Êtes-vous sûr?",
      text: "Vous ne pourrez pas revenir en arrière!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le!",
      cancelButtonText: "Annuler",
    });

    if (result.isConfirmed) {
      try {
        await deleteProducerApi(producerId);

        Swal.fire({
          title: "Supprimé!",
          text: "Le producteur a été supprimé avec succès.",
          icon: "success",
        });

        const newCurrentPage =
          tableData.producers.length === 1 && currentPage > 1 ? currentPage - 1 : currentPage;

        getTableData(
          nameSearch,
          emailSearch,
          pseudoSearch,
          typeSearch,
          statusFilter,
          newCurrentPage,
          limitPerPage
        );

        if (newCurrentPage !== currentPage) {
          setCurrentPage(newCurrentPage);
        }
      } catch (error) {
        console.error("Error deleting producer:", error.response?.data?.error || error.message);
        toast.error(
          error.response?.data?.error ||
            "Une erreur s'est produite lors de la suppression du producteur."
        );
      }
    }
  };

  const handleRefreshData = () => {
    getTableData(
      nameSearch,
      emailSearch,
      pseudoSearch,
      typeSearch,
      statusFilter,
      currentPage,
      limitPerPage
    );
  };

  const handleNameSearchChange = (event) => {
    setNameSearch(event.target.value);
  };

  const handleEmailSearchChange = (event) => {
    setEmailSearch(event.target.value);
  };

  const handlePseudoSearchChange = (event) => {
    setPseudoSearch(event.target.value);
  };

  const handleTypeSearchChange = (event) => {
    setTypeSearch(event.target.value);
  };

  const handleStatusFilterChange = (status) => {
    setStatusFilter(status);
    closeMenu();
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleApplyFilters = () => {
    setLoading(true);
    setCurrentPage(1);

    getTableData(nameSearch, emailSearch, pseudoSearch, typeSearch, statusFilter, 1, limitPerPage);
  };

  const handleStatusChange = async (producerId, currentStatus) => {
    setTableData((prevData) => ({
      ...prevData,
      producers: prevData.producers.map((p) =>
        p._id === producerId ? { ...p, isActive: !p.isActive } : p
      ),
    }));

    try {
      await toggleProducerStatusApi(producerId);
      toast.success("Statut mis à jour avec succès !");
    } catch (error) {
      toast.error("Échec de la mise à jour du statut. Veuillez réessayer.");
      setTableData((prevData) => ({
        ...prevData,
        producers: prevData.producers.map((p) =>
          p._id === producerId ? { ...p, isActive: currentStatus } : p
        ),
      }));
    }
  };

  const renderMenu = (
    <Menu
      anchorEl={menu}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      open={Boolean(menu)}
      onClose={closeMenu}
      keepMounted
    >
      <MenuItem onClick={() => handleStatusFilterChange("Activée")}>Activée</MenuItem>
      <MenuItem onClick={() => handleStatusFilterChange("Disactivée")}>Disactivée</MenuItem>
      <Divider sx={{ margin: "0.5rem 0" }} />
      <MenuItem onClick={() => handleStatusFilterChange("Tous")}>
        <MDTypography variant="button" color="success" fontWeight="regular">
          Tous
        </MDTypography>
      </MenuItem>
    </Menu>
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={0} mb={9} p={1}>
        <Grid container spacing={1} alignItems="center" mb={2}>
          <Grid item xs={12} md={2}>
            <MDInput
              type="text"
              label="Recherche par nom"
              size="small"
              fullWidth
              value={nameSearch}
              onChange={handleNameSearchChange}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <MDInput
              type="email"
              label="Recherche par email"
              size="small"
              fullWidth
              value={emailSearch}
              onChange={handleEmailSearchChange}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <MDInput
              type="text"
              label="Recherche par Pseudo"
              size="small"
              fullWidth
              value={pseudoSearch}
              onChange={handlePseudoSearchChange}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <MDInput
              type="text"
              label="Recherche par type"
              size="small"
              fullWidth
              value={typeSearch}
              onChange={handleTypeSearchChange}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <MDButton
              variant={menu ? "contained" : "outlined"}
              color="dark"
              onClick={openMenu}
              fullWidth
            >
              {`Statut: ${statusFilter}`}
              <Icon>keyboard_arrow_down</Icon>
            </MDButton>
            {renderMenu}
          </Grid>
          <Grid item xs={12} md={2}>
            <MDButton
              variant="contained"
              color="info"
              onClick={handleApplyFilters}
              fullWidth
              disabled={loading}
            >
              Filtrer
            </MDButton>
          </Grid>
        </Grid>
        <Card>
          <TableContainer component={Paper} mt={0}>
            {loading ? (
              <Box display="flex" justifyContent="center" alignItems="center" height="200px">
                <CircularProgress />
              </Box>
            ) : (
              <>
                <Table aria-label="producteurs table">
                  <TableHead style={{ display: "table-header-group" }}>
                    <TableRow>
                      <TableCell
                        align="left"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Actions
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Producteur
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Type
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Email
                      </TableCell>
                      <TableCell
                        align="left"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Nom d'utilisateur
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          color: "#7b809a",
                          fontSize: "0.7rem",
                          opacity: "0.7",
                          textTransform: "uppercase",
                        }}
                      >
                        Statut
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tableData.producers.map((producer) => (
                      <TableRow
                        key={producer._id}
                        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                      >
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.8rem",
                            fontWeight: "600",
                            width: "120px",
                          }}
                        >
                          <Stack direction="row" spacing={1}>
                            <IconButton
                              color="info"
                              size="small"
                              onClick={() => handleEdite(producer)}
                              sx={{ padding: "4px" }}
                            >
                              <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              color="error"
                              size="small"
                              onClick={() => handleDeleteItem(producer._id)}
                              sx={{ padding: "4px" }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Stack>
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{
                            color: "#7b809a",
                            fontSize: "0.8rem",
                            fontWeight: "600",
                          }}
                        >
                          <MDTypography
                            component="a"
                            href="#"
                            variant="caption"
                            color="text"
                            fontWeight="medium"
                          >
                            {`${producer.firstName} ${producer.lastName}`}
                          </MDTypography>
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "400" }}
                        >
                          {producer.type}
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "400" }}
                        >
                          {producer.email}
                        </TableCell>
                        <TableCell
                          align="left"
                          style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "400" }}
                        >
                          {producer.pseudo}
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ color: "#7b809a", fontSize: "0.8rem", fontWeight: "600" }}
                        >
                          <FormControlLabel
                            control={
                              <Switch
                                checked={producer.isActive}
                                onChange={() => handleStatusChange(producer._id, producer.isActive)}
                                color="success"
                              />
                            }
                            label={producer.isActive ? "enable" : "disable"}
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
                {tableData.pages > 1 && (
                  <MDBox display="flex" justifyContent="center" mt={2} mb={2}>
                    <Pagination
                      count={tableData.pages}
                      page={tableData.page}
                      onChange={handlePageChange}
                      color="info"
                    />
                  </MDBox>
                )}
              </>
            )}
          </TableContainer>
        </Card>
      </MDBox>
      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </DashboardLayout>
  );
}

export default ProducteursList;
